
import amBlogAuthorQuery from '~/graphql/articles/amBlogAuthor.graphql'
import amBlogPostQuery from '~/graphql/articles/amBlogPost.graphql'
import { isNullish } from '~/utils/Utils'
import { formatDate, dateTime } from '~/services/dateTime/dateTime'
import { getCanonicalUrl } from '~/services/canonicalUrl/canonicalUrl'
import blogStaticPageUrlKeys from '~/config/blogStaticPageUrlKeys'

export default {
  middleware: ['hasRedirect', 'isBlogPage'],

  async asyncData ({ app, params, redirect, error }) {
    const { pathMatch } = params
    const isStaticPage = blogStaticPageUrlKeys.includes(pathMatch)

    let article
    let author

    await app.$graphql({
      requestPayload: {
        query: amBlogPostQuery,
        variables: {
          urlKey: pathMatch,
        },
      },
      successHandler: ({ data: { amBlogPost } }) => {
        article = amBlogPost
      },
    })

    const { postId, urlKey } = article

    if (isNullish(article) || !urlKey || !postId) {
      if (app.i18n.locale === 'en') {
        return redirect('/en/ac')
      }
      return error({
        statusCode: 404,
        message: app.i18n.t('Article.Article does not exist'),
      })
    }

    if (article.authorId) {
      await app.$graphql({
        requestPayload: {
          query: amBlogAuthorQuery,
          variables: {
            id: +article.authorId,
          },
        },
        successHandler: ({ data: { amBlogAuthor } }) => {
          author = amBlogAuthor
        },
      })
    }

    return {
      ...article,
      isStaticPage,
      author,
      formattedDateEdited: formatDate(app.i18n.locale).getNumericDateFullYear(dateTime(article.editedAt)),
      formattedDateCreated: formatDate(app.i18n.locale).getNumericDateFullYear(dateTime(article.createdAt)),
      categories: article.categories.split(','),
    }
  },

  head () {
    return {
      title: this.metaTitle,
      meta: [{
        hid: 'description',
        name: 'description',
        content: this.metaDescription || '',
      },
      {
        hid: 'robots',
        name: 'robots',
        content: this.metaRobots || '',
      }],

      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: getCanonicalUrl(this.$route, this.$config.appUrl),
        },
      ],
    }
  },

  mounted () {
    this.$gtm.push({ event: 'page_view' })
  },

  jsonld () {
    return {
      '@context': 'https://schema.org/',
      '@type': 'Article',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': `${this.$config.appUrl}${this.$route.fullPath}`,
        headline: this.title || '',
        description: this.metaDescription || '',
        image: this.postThumbnail || '',
        datePublished: this.publishedAt || '',
        dateModified: this.updatedAt || '',

        author: {
          '@type': this.authorId === 6 ? 'Person' : 'Organization',
          name: this.author.name || '',

          // @todo jak wejdą strony autorów blogowych
          // url: `${this.$config.appUrl}/${this.author.urlKey}` || '',
        },

        publisher: {
          '@type': 'Organization',
          name: this.$config.storeName || '',
          logo: {
            '@type': 'ImageObject',
            url: `${this.$config.appUrl}/logo/logo-${this.$config.storeCode}.jpg`,
          },
        },
      },
    }
  },
}
